import React from 'react';
import {
  ReferenceField,
  useRecordContext,
} from 'react-admin';

import get from 'lodash/get';

import DateFieldCheck from './DateFieldCheck';
import entityTypes, { EntityTypes } from '../constants/entityTypes';

const ReferenceLastKycRequest = ({
  source = 'entity',
}: {
  source?: string;
  label: string;
}) => {
  const record = useRecordContext();
  const value: {
    type: EntityTypes;
    id: string;
  } = source ? get(record, source, {}) : record;
  const idSource = source ? `${source}.id` : 'id';
  if (value.type === entityTypes.INDIVIDUAL) {
    return (
      <ReferenceField label="Individual" source={idSource} reference="individuals" link={false}>
        <DateFieldCheck source="kycApprovedAt" />
      </ReferenceField>
    );
  }
  if (value.type === entityTypes.BUSINESS) {
    return (
      <ReferenceField label="Business" source={idSource} reference="businesses" link={false}>
        <DateFieldCheck source="kycApprovedAt" />
      </ReferenceField>
    );
  }
  if (value.type === entityTypes.CAR) {
    return (
      <ReferenceField label="Car" source={idSource} reference="cars" link={false}>
        <DateFieldCheck source="kycApprovedAt" />
      </ReferenceField>
    );
  }
  if (value.type === entityTypes.ACCOUNT) {
    return (
      <ReferenceField label="Account" source={idSource} reference="account-entities" link={false}>
        <DateFieldCheck source="kycApprovedAt" />
      </ReferenceField>
    );
  }
  if (value.type === entityTypes.PRODUCT) {
    return (
      <ReferenceField label="Product" source={idSource} reference="products" link={false}>
        <DateFieldCheck source="kycApprovedAt" />
      </ReferenceField>
    );
  }
  return null;
};

export default ReferenceLastKycRequest;
